/* eslint-disable import/prefer-default-export */
// Size of document base font for calculating rems
export const baseFontSize = '16px';
